import React, { Component, useEffect } from "react";
import ReactTable from "react-table";
import { Container, Row, Col } from "reactstrap";
import "../../_Content/css/eco-template.css";
import TooltipDescricaoErro from "../../Componente/Common/TooltipDescricaoErro";

class TabelaDfe extends Component {
  constructor(props) {

    super(props);
    this.state = {
      chavesData: [{
        aud: this.props.setDataDFE.DivergenciaDocsEscriturados,
        dfe: this.props.setDataDFE.DivergenciaDocsDFe,
      }],
      originalData: this.props.setDataDFE,
      botaoMostrarTodas: false,
      colunasDfe: [
        {
          Header: "Tipo",
          className: "text-center txt",
          accessor: "tpDfe",
          maxWidth: 50,
          Cell: row => (
            <span className="flexCenter">
              <span className={this.validarLinhaInteira(row.original)}>
                {row.value}
              </span>
            </span>
          )
        },
        {
          Header: "Chave",
          accessor: "chaveNota",
          className: "text-center txt",
          // maxWidth: 100,
          Cell: row => (
            <span className="flex">
              <span 
                title={row.value}
                className={this.validarLinhaInteira(row.original)}
              >
                {row.value}
                {/* <TooltipDescricaoErro id={row.index} text={row.value} /> */}
              </span>
            </span>
          )
        },
        {
          Header: "Data",
          accessor: "dtEmissao",
          className: "text-center txt",
          maxWidth: 100,
          Cell: row => (
            <span className="flexCenter">
              <span className={this.validarLinhaInteira(row.original, "dtEmissao")}>
                {this.formatarData(row.value)}
              </span>
            </span>
          )
        },
        {
          Header: "Emitente",
          accessor: "emitente",
          className: "text-center txt",
          maxWidth: 300,
          Cell: row => (
            <span className="flex">
              <span 
                className={this.validarLinhaInteira(row.original, "emitente")}
                title={row.value}
              >
                <TooltipDescricaoErro id={row.index} text={row.value} />
              </span>
            </span>
          )
        },
        {
          Header: "Valor",
          accessor: "valorNotaDFe",
          className: "text-center txt",
          maxWidth: 100,
          Cell: row => (
            <span className="flex">
              <span className={this.validarLinhaInteira(row.original, "valorNotaDFe")}>
                R$ {row.value}
              </span>
            </span>
          )
        },
        {
          Header: "Info. do Doc.",
          accessor: "tpNota",
          className: "text-center txt",
          maxWidth: 80,
          Cell: row => (
            <span className="flexCenter">
              <span className={this.validarLinhaInteira(row.original, "tpNota")}>
                {row.value}
              </span>
            </span>
          )
        },
        {
          Header: "Status",
          // accessor: "status",
          className: "text-center txt",
          maxWidth: 130,
          Cell: row => (
            <span className="flexCenter">
              <span className={this.validarLinhaInteira(row.original, "erros")}>
                {this.validarLinhaInteira(row.original, "erros")}
              </span>
            </span>
          )
        },
        {
					expander: true,
					className: "colBtns",
					width: 50,
					Expander: ({ isExpanded, ...rest }) => {
              if (rest.original.ValoresDocumento.length==0) {
                return null;
              } else {
                return (
                  <div>
                    {isExpanded ? (
                      <i className="ecoico ecoico-arrow-up"></i>
                    ) : (
                      <i className="ecoico ecoico-arrow-down"></i>
                    )}
                  </div>
                )
              }
            },
            getProps: (state, rowInfo, column) => {
              if(rowInfo)
              {
                // same test as above
                if(rowInfo.original.ValoresDocumento && rowInfo.original.ValoresDocumento.length == 0)
                {
                  // hijack the onClick so it doesn't open
                  return {
                    onClick: () => {},
                  }
                }
              }
              return {
                className: 'show-pointer', 
              };
            },
				}
      ],
      colunasChaves: [
        {
          // Header: "Documentos Fiscais não sincronizados",
          Header: () => (
            <span>
              Documentos Fiscais não sincronizados
              <span 
                class='ecoico ecoico-nao-realizada'
                title="Os documentos abaixo não constam no EcoDFe, favor verificar. 
                Se possível, realize uma nova sincronização."
              >
              </span>
            </span>
          ),
          className: "text-center textBigger txt",
          accessor: "",
          // maxWidth: 300,
          Cell: row => (
            <span className="">
              {
                row.original.aud ?
                row.original.aud.length :
                <span>-</span>
              }
                {/* <span class='ecoico ecoico-nao-realizada'>
              </span> */}
            </span>
          )
        },
        {
          // Header: "Documentos Fiscais não escriturados",
          Header: () => (
            <span>
              Documentos Fiscais não escriturados
              <span 
                class='ecoico ecoico-nao-realizada'
                title='Os documentos abaixo não constam no arquivo escriturado, favor verificar.'
              >
              </span>
            </span>
          ),
          className: "text-center textBigger txt",
          // accessor: "DivergenciaDocsDFe",
          // maxWidth: 300,
          Cell: row => (
            <span>
              {
                row.original.dfe ?
                row.original.dfe.length :
                <span>-</span>
              }
            </span>
          )
        },
        {
					expander: true,
					className: "colBtns",
					width: 50,
					Expander: ({ isExpanded, ...rest }) => {
            return (
              <div>
                {isExpanded ? (
                  <i className="ecoico ecoico-arrow-up"></i>
                ) : (
                  <i className="ecoico ecoico-arrow-down"></i>
                )}
              </div>
            )    
          },
          getProps: (state, rowInfo, column) => {
            if(rowInfo)
            {
              // same test as above
              if(rowInfo.original.aud && rowInfo.original.aud.length == 0 && rowInfo.original.dfe.length == 0)
              {
                // hijack the onClick so it doesn't open
                return {
                  onClick: () => {},
                }
              }
            }
            return {
              className: 'show-pointer', 
            };
          },
				}
      ],
    }
  }

  redirect = () =>{
    window.open("https://dfe.econeteditora.com.br/", "_blank");
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.setDataDFE != this.state.originalData) {
      this.setState({ 
        originalData: nextProps.setDataDFE,
        chavesData: [{
          aud: nextProps.setDataDFE.DivergenciaDocsEscriturados,
          dfe: nextProps.setDataDFE.DivergenciaDocsDFe,
        }]
    })
    }
  }

  validarLinhaInteira = (row, _coluna) => {
    if (row.ValoresDocumento.length>0) {
      if (_coluna == "erros") {
        return (
          <div className="boxErro">
            {
              row.ValoresDocumento.length==1
              ? 
              <span className="errosEncontrados">
                {row.ValoresDocumento.length} erro
              </span>
              :
              <span className="errosEncontrados">
                {row.ValoresDocumento.length} erros
              </span>
            }
          </div>
        )
      } else {
        return 'errosEncontrados'
      }
    }
    return (
      <div className="boxNormal">
        Validada
      </div>
    )
  };

  formatarData = (props) => {
    const dia = props.split('T')[0].split('-')[2];
    const mes = props.split('T')[0].split('-')[1];
    const ano = props.split('T')[0].split('-')[0];
  
    const dataFormatada = `${dia}/${mes}/${ano}`;
    return dataFormatada;
  };

  subComponentMapper = row => {
		return (
			<Container className="tabelaSubComponent">
        {
          row.original.ValoresDocumento.map((item) => {
            return <span className="tabelaListaErros">
              <span>
                <b className="colorLightBlue">Sugestão Econet:</b>
                <i>{item.msgErro}</i>
              </span>
              <table width="80%" border="1" bordercolor="#B9DEFD" style={{borderCollapse: "collapse"}}>
                <thead>
                  <tr className="text-center">
                    <th>Linha</th>
                    <th>Registro</th>
                    <th>Valor EcoAuditor</th>
                    <th>Valor EcoDFe</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="text-center">
                    <td>
                      {item.linha}
                    </td>
                    <td>
                      {item.registro}
                    </td>
                    <td>
                      {item.vlAuditor}
                    </td>
                    <td>
                      {item.vlDFe}
                    </td>
                  </tr>
                </tbody>
              </table>
            </span>
          })
        }
			</Container>
		);
	};

  subComponentMapperChaves = row => {
		return (
			<Container className="tabelaSubComponent">
        {
          <span>
            <Row>
              <Col md={1}></Col>
              <Col md={4}></Col>
              <Col md={2} className='border-custom'></Col>
              <Col md={4}></Col>
              <Col md={1}></Col>
            </Row>
            <Row>
              <Col>
                <table  border="1" bordercolor="#B9DEFD" style={{borderCollapse: "collapse"}}>
                  <thead>
                    <tr className="text-center">
                      <th width="800">Escrituradas</th>
                      <th width="800">Sincronizados</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="text-center">
                      <td>
                        {
                          row.original.aud.map((item) => {
                            return (
                              // <tr className="text-center">
                                <p>
                                  {item.chaveNota}
                                </p>
                              // </tr>
                            )
                          })
                        }
                      </td>
                      <td className='align-top'>
                        {
                          row.original.dfe.map((item) => {
                            return (
                              // <tr className="text-center">
                                <p>
                                  {item.chaveNota}
                                </p>
                              // </tr>
                            )
                          })
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </span>
        }
			</Container>
		);
	};

  render() {
    return (
      <div>
        {
          this.props.isReady 
          ?
          <Container className="bottomBar">
            <div className="boxResumo">
              <div className="boxCimaTabela flex-custom">
                <div className='boxInfos flex-custom-column'>
                  <div className="boxSolucoes resumo">
                    <b>EcoAuditor</b>
                  </div>
                  <div className="boxSolucoes flex-custom">
                    <div className="spacingCustom flex-custom-column resumo boxMenor">
                      <div>
                        Total Registros C100: 
                      </div>
                      <div>
                        <b>
                          {this.state.originalData.qtdeRegistrosEscrituradosC100}
                        </b>
                      </div>
                    </div>
                    <div className="spacingCustom flex-custom-column resumo boxMenor">
                      <div>
                        Total Registros D100:
                      </div>
                      <div>
                        <b>
                          {this.state.originalData.qtdeRegistrosEscrituradosD100}
                        </b>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='boxInfos flex-custom-column'>
                  <div className="boxSolucoes resumo">
                    <b>EcoDFe</b>
                  </div>
                  <div className="boxSolucoes flex-custom">
                    <div className="spacingCustom flex-custom-column resumo boxMenor">
                      <div>
                        Total NFe Sincronizadas:
                      </div>
                      <div>
                        <b>
                          {this.state.originalData.qtdeNFeSincronizados}
                        </b>
                      </div>
                    </div>
                    <div className="spacingCustom flex-custom-column resumo boxMenor">
                      <div>
                        Total CTe Sincronizados: 
                      </div>
                      <div>
                        <b>
                          {this.state.originalData.qtdeCTeSincronizados}
                        </b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="boxTabela">
                <ReactTable
                  data={this.state.chavesData}
                  columns={this.state.colunasChaves}
                  className="eco-react-table"
                  loading={!this.props.setDataDFE}
                  showPagination={false}
                  SubComponent={this.subComponentMapperChaves}
                  pageSize='1'
                />
              </div>
            </div>
            <ReactTable
              data={this.state.originalData.DocumentosDFe}
              columns={this.state.colunasDfe}
              className="eco-react-table"
              loading={!this.props.setDataDFE}
              showPagination={false}
              SubComponent={this.subComponentMapper}
              noDataText="Não foram encontrados os documentos fiscais no EcoDFe apontados no arquivo EFD, para a Empresa em questão e no período informado. Favor verificar se a mesma encontra-se cadastrada no EcoDFe e há documentos fiscais deste período. Em caso de cadastro existente, realize uma nova sincronização."
              pageSize={this.state.originalData.DocumentosDFe.length}
            />
          </Container>
          :
          <Container>
            {
              this.props.showLoadingDFe
              ?
              <div className='boxDFe'>Carregando...</div>
              :
              <div>
                <div className='boxDFe'>
                  <i class='ecoico ecoico-alerta-new'></i>
                  <p><b>Antes de começarmos</b></p>
                  <div className="blueSign">
                    {/* <img src={require('/img/ecoicos/ecoico-alerta-new.svg')} width="50"></img> */}
                    As informações validadas não serão salvas nesta solução.
                  </div>
                  <p>
                    Antes de cruzar os dados da escrituração fiscal com o EcoDFe, 
                    por favor atualizar a sincronização dos documentos no EcoDFe.
                  </p>
                  <div className='buttonsDFe'>
                    <button 
                      className='btnIrParaDFe'
                      onClick={this.redirect}
                    >
                      Ir para EcoDFe
                    </button>
                    <button 
                      className='btnCruzarDados'
                      onClick={this.props.buscarDFe}
                    >
                      Cruzar Dados
                      <i className='icon-arrow-right'></i>
                    </button>
                  </div>
                </div>
              </div>
            }
          </Container>
        }
      </div>
    )
  }
}

export default TabelaDfe;


// WEBPACK FOOTER //
// ./src/Componente/Resultado/TabelaDfe.jsx